import { ValueProvider } from '@angular/core';
import { ENVIRONMENT } from '../tokens/environment';
import { Environment } from '../models/environment';

export const provideEnvironment = (environment: Environment): ValueProvider => ({
    provide: ENVIRONMENT,
    useValue: environment
});
